export default {
  singleLabel: "Demande de location pour compte",
  storeNamespace: 'location_for_account',
  authFeature: 'location-for-account',
  listRouteName: "LocationForAccountList",
  detailRouteName: "LocationForAccountDetail",
  // Une demande naît en boutique : le back-office la traite, il ne la crée pas.
  hideActionNewButton: true,
  hideActionDeleteButton: true,
  csvExportFilenamePrefix: 'locations-pour-compte',
  titleField: 'number',
  sortBy: 'created_at',
  sortDesc: true,
  showExtendedFilters: true,
  fields: [
    {
      name: 'number',
      label: "Numéro",
      type: 'text',
      inList: true,
      sortable: true,
      inCsvExport: true,
    },
    {
      name: 'created_at',
      label: "Date de création",
      type: 'date',
      inList: true,
      sortable: true,
      inCsvExport: true,
    },
    {
      name: 'agency_number',
      label: "Agence",
      type: 'text',
      inList: true,
      sortable: true,
      inCsvExport: true,
    },
    {
      name: 'business_number',
      label: "Affaire",
      type: 'text',
      inList: true,
      sortable: true,
      inCsvExport: true,
    },
    {
      name: 'site_name',
      label: "Chantier",
      type: 'text',
      inList: true,
      sortable: true,
      inCsvExport: true,
    },
    {
      name: 'product_name',
      label: "Matériel",
      type: 'text',
      inList: true,
      sortable: true,
      inCsvExport: true,
    },
    {
      name: 'quantity',
      label: "Qté",
      type: 'number',
      inList: true,
      sortable: true,
      inCsvExport: true,
    },
    {
      name: 'company_name',
      label: "Loueur",
      type: 'text',
      inList: true,
      sortable: true,
      inCsvExport: true,
    },
    {
      name: 'planned_start_date',
      label: "Début prévu",
      type: 'date',
      inList: true,
      sortable: true,
      inCsvExport: true,
    },
    {
      name: 'planned_end_date',
      label: "Fin prévue",
      type: 'date',
      inList: true,
      sortable: true,
      inCsvExport: true,
    },
    {
      // Calculé côté serveur sur la date de fin PRÉVUE, et seulement pour une location en
      // cours : une demande close ou refusée n'a pas de jours restants.
      name: 'remaining_days',
      label: "Jours restants",
      type: 'number',
      inList: true,
      sortable: false,
      inCsvExport: true,
    },
    {
      name: 'daily_price_ht',
      label: "Prix journalier HT",
      type: 'number',
      inList: true,
      sortable: false,
      inCsvExport: true,
      formatter: (context, value) => value ? parseFloat(value).toFixed(2) + '€' : null,
    },
    {
      // Statuts en onglets, au-dessus de la zone de filtres (SFD 2.10 § Suivi). Le mécanisme
      // est natif à AdminTableSync : un seul champ marqué `tabFilter`.
      name: 'status_slug',
      label: "Statut",
      type: 'select',
      inList: true,
      sortable: true,
      tabFilter: true,
      inCsvExport: true,
      formatter: (context, value) => value
        ? context.$store.getters['location_for_account/getStatusLabel'](value)
        : null,
    },

    // --- Filtres seuls, absents des colonnes -------------------------------------------
    {
      // 461 agences : un autocomplete, pas une liste déroulante. Le composant charge son
      // propre référentiel, la vue n'a rien à lui fournir.
      name: 'agency', label: "Agence", type: 'autocomplete',
      filterComponent: 'AgencyAutocomplete', filterPlaceholder: "Recherchez une agence…",
      inList: false, extendedFilter: true, filterOrder: 1,
    },
    {
      // 690 000 affaires : ni liste déroulante, ni autocomplete chargeant tout le
      // référentiel. Un champ texte, filtré côté serveur sur le numéro d'affaire — c'est
      // par lui qu'on cherche, et il est saisi tel quel dans les échanges.
      name: 'business', label: "N° d'affaire", type: 'text',
      inList: false, extendedFilter: true, filterOrder: 2,
    },
    { name: 'product', label: "Matériel", type: 'chosen', inList: false, extendedFilter: true, filterOrder: 3 },
    { name: 'company', label: "Loueur", type: 'chosen', inList: false, extendedFilter: true, filterOrder: 4 },
    { name: 'created', label: "Date de création", type: 'date', inList: false, extendedFilter: true, filterOrder: 5 },
    { name: 'start', label: "Date de début", type: 'date', inList: false, extendedFilter: true, filterOrder: 6 },
    { name: 'end', label: "Date de fin prévue", type: 'date', inList: false, extendedFilter: true, filterOrder: 7 },
    {
      // « Arrive à terme » se lit sur le seuil administrable (2 jours par défaut) : le libellé
      // de l'option est construit par la vue, qui connaît la valeur du paramètre.
      name: 'deadline',
      label: "Échéance",
      type: 'select',
      inList: false,
      extendedFilter: true,
      filterOrder: 8,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/components/LocationForAccount/config.js